import {Dropdown, Form, FormGroup} from "semantic-ui-react";
import styles from "../../DataInspector/DataInspector.module.css";
import React, {useEffect, useState} from "react";
import {equipmentService} from "../../../services/equipmentService";
import {dataInspectorService} from "../../../services/DataInspectorService";

export const EquipmentDashboardForm = ({equipmentId, onSubmit}) => {
    const today = new Date();

    //form fields
    const [reportStartDate, setReportStartDate] = useState(`${today.getFullYear()}-01-01`);
    const [reportEndDate, setReportEndDate] = useState(`${today.getFullYear()}-${(today.getMonth() + 1).toString().padStart(2, "0")}-${today.getDate()}`);
    const [benchmarkYear, setBenchmarkYear] = useState(today.getFullYear() - 1);
    const [blendedElectricRate, setBlendedElectricRate] = useState(0.07);
    const [blendedThermalRate, setBlendedThermalRate] = useState(5.60);

    //options
    const [energyPointOptions, setEnergyPointOptions] = useState([]);
    const [detailPointOptions, setDetailPointOptions] = useState([]);
    const [energyFunctionOptions, setEnergyFunctionOptions] = useState([]);
    const [detailFunctionOptions, setDetailFunctionOptions] = useState([]);

    //selections
    const [selectedEnergyPoints, setSelectedEnergyPoints] = useState([]);
    const [selectedDetailPoints, setSelectedDetailPoints] = useState([]);
    const [selectedEnergyFunctions, setSelectedEnergyFunctions] = useState([]);
    const [selectedDetailFunctions, setSelectedDetailFunctions] = useState([]);

    const [errors] = useState();
    const [loading, setLoading] = useState(false);


    useEffect(() => {
        loadPoints(equipmentId);
        loadFunctions(equipmentId);
    }, []);

    const loadPoints = async (equipmentId) => {
        const equipmentPoints = await dataInspectorService.getEquipmentPoints({
            equipmentIds: [equipmentId],
            buildingIds: []
        }, false, true);

        setEnergyPointOptions(equipmentPoints.filter(point => point.pointType === 'EP' && !point.stale).map(point => ({
            key: point.pointId,
            value: point.pointId,
            text: point.description + ' (' + point.pointCode + ')',
            code: point.pointCode
        })));

        setDetailPointOptions(equipmentPoints.filter(point => point.pointType !== 'EP' && point.pointType !== 'NP' && !point.stale).map(point => ({
            key: point.pointId,
            value: point.pointId,
            text: point.description + ' (' + point.pointCode + ')',
            code: point.pointCode
        })));

    };

    const loadFunctions = async (equipmentId) => {
        const equipmentFunctions = await dataInspectorService.getEquipmentFunctions({
            equipmentIds: [equipmentId],
            buildingIds: []
        }, false);

        const result = [];

        for (let i = 0; i < equipmentFunctions.length; i++) {
            const current = equipmentFunctions[i];

            if(current.hidden) {
                continue;
            }

            const func = {
                key: current.equipmentId + '-' + current.functionId,
                value: current.equipmentId + '-' + current.functionId,
                text: current.description + ' (' + current.name + ')',
                type: 'function',
                code: current.name,
                id: current.functionId,
                equipment: current.equipmentId,
                energy: ""+current.isEnergyFunction //TODO the kendo dropdown doesn't like boolean values, not sure how to fix it yet but using a string works
            };

            result.push(func);
        }

        //TODO related to above issue with boolean values
        setEnergyFunctionOptions(result.filter(x => x.energy === "true"));
        setDetailFunctionOptions(result.filter(x => !(x.energy === "true")));
    };

    const handleEnergyPointChange = selectedItems => {
        if (selectedItems.length > 0) {
            var temp = [];
            selectedItems.forEach(function (pointDropdownKey) {
                let point = detailPointOptions?.find(x => x.key === pointDropdownKey);
                temp.push(point);
            });
            setSelectedEnergyPoints(temp);
        } else {
            setSelectedEnergyPoints([]);
        }
    };

    const handleDetailPointChange = selectedItems => {
        if (selectedItems.length > 0) {
            var temp = [];
            selectedItems.forEach(function (pointDropdownKey) {
                let point = detailPointOptions?.find(x => x.key === pointDropdownKey);
                console.log(point);
                temp.push(point);
            });
            setSelectedDetailPoints(temp);
        } else {
            setSelectedDetailPoints([]);
        }
    };

    const handleEnergyFunctionChange = selectedItems => {
        if (selectedItems.length > 0) {
            const temp = [];
            selectedItems.forEach(function (functionDropdownKey) {
                console.log(functionDropdownKey);
                let tempFunction = energyFunctionOptions?.find(x => x.key === functionDropdownKey);
                console.log(tempFunction);
                temp.push(tempFunction);
            });
            setSelectedEnergyFunctions(temp);
        } else {
            setSelectedEnergyFunctions([]);
        }
    };

    const handleDetailFunctionChange = selectedItems => {
        if (selectedItems.length > 0) {
            const temp = [];
            selectedItems.forEach(function (functionDropdownKey) {
                let tempFunction = detailFunctionOptions?.find(x => x.key === functionDropdownKey);
                temp.push(tempFunction);
            });
            setSelectedDetailFunctions(temp);
        } else {
            setSelectedDetailFunctions([]);
        }
    };

    const handleSubmit = async () => {
        setLoading(true);

        const formData = {
            equipmentId: equipmentId,
            reportStartDate: reportStartDate,
            reportEndDate: reportEndDate,
            benchmarkYear: benchmarkYear,
            blendedElectricRate: blendedElectricRate,
            blendedThermalRate: blendedThermalRate,
            energyPoints: selectedEnergyPoints,
            energyFunctions: selectedEnergyFunctions,
            detailPoints: selectedDetailPoints,
            detailFunctions: selectedDetailFunctions
        }

        onSubmit(formData);
        setLoading(false);
    }

    return (
        <Form onSubmit={handleSubmit} error={!!errors}>
            <Form.Group>
                <Form.Input
                    width={2}
                    className={styles.inspectorInput}
                    type={'date'}
                    defaultValue={reportStartDate}
                    label="Report Start Date"
                    placeholder="Time Range"
                    onChange={e => setReportStartDate(e.target.value)}
                />
                <Form.Input
                    width={2}
                    className={styles.inspectorInput}
                    type={'date'}
                    defaultValue={reportEndDate}
                    label="Report End Date"
                    placeholder="Time Range"
                    onChange={e => setReportEndDate(e.target.value)}
                />
                <Form.Input
                    width={2}
                    label="Benchmark Year"
                    type={'number'}
                    min={1900}
                    step={1}
                    value={benchmarkYear}
                    required
                    onChange={e => setBenchmarkYear(e.target.value)}
                />
                {/*<div className={"two wide field"}>*/}
                {/*    <label>Energy Points</label>*/}
                {/*    <Dropdown*/}
                {/*        className={styles.inspectorDropdown}*/}
                {/*        label="Energy Points"*/}
                {/*        placeholder="Points"*/}
                {/*        options={energyPointOptions}*/}
                {/*        value={selectedEnergyPoints.map(f => f.key)}*/}
                {/*        onChange={(e, {value}) => {*/}
                {/*            handleEnergyPointChange(value);*/}
                {/*        }}*/}
                {/*        multiple*/}
                {/*        selection*/}
                {/*        search*/}
                {/*        clearable*/}
                {/*    />*/}
                {/*</div>*/}
                <div className={"two wide field"}>
                    <label>Energy Functions</label>
                    <Dropdown
                        className={styles.inspectorDropdown}
                        label="Energy Functions"
                        placeholder="Functions"
                        options={energyFunctionOptions}
                        value={selectedEnergyFunctions.map(f => f.key)}
                        onChange={(e, {value}) => {
                            handleEnergyFunctionChange(value);
                        }}
                        multiple
                        selection
                        search
                        clearable
                    />
                </div>
                <div className={"two wide field"}>
                    <label>Detail Points</label>
                    <Dropdown
                        className={styles.inspectorDropdown}
                        label="Detail Points"
                        placeholder="Points"
                        options={detailPointOptions}
                        value={selectedDetailPoints.map(f => f.key)}
                        onChange={(e, {value}) => {
                            handleDetailPointChange(value);
                        }}
                        multiple
                        selection
                        search
                        clearable
                    />
                </div>
                <div className={"two wide field"}>
                    <label>Detail Functions</label>
                    <Dropdown
                        className={styles.inspectorDropdown}
                        label="Detail Functions"
                        placeholder="Functions"
                        options={detailFunctionOptions}
                        value={selectedDetailFunctions.map(f => f.key)}
                        onChange={(e, {value}) => {
                            handleDetailFunctionChange(value);
                        }}
                        multiple
                        selection
                        search
                        clearable
                    />
                </div>
            </Form.Group>
            <FormGroup>
                <Form.Input
                    width={3}
                    label="Blended Electric Rate ($/kWh)"
                    type={'number'}
                    value={blendedElectricRate}
                    step={0.01}
                    onChange={e => setBlendedElectricRate(e.target.value)}
                    required
                />
                <Form.Input
                    width={3}
                    label="Blended Thermal Rate ($/MCF)"
                    type={'number'}
                    value={blendedThermalRate}
                    step={0.01}
                    onChange={e => setBlendedThermalRate(e.target.value)}
                    required
                />
            </FormGroup>
            <FormGroup>
                <Form.Button size={'large'} loading={loading} color={'blue'}>
                    Submit
                </Form.Button>
            </FormGroup>
        </Form>
    );
}
